// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1QbN2","content":"Consent_content__3YG2I","footer":"Consent_footer__1Bge9"};